const actions = {
    FETCH_DASHBOARD_DATA: "FETCH_DASHBOARD_DATA",
    LOAD_SITE_LIST: "LOAD_SITE_LIST",
};

export default actions;
